import { render, staticRenderFns } from "./SourceModal.vue?vue&type=template&id=4ff8a9ba&"
import script from "./SourceModal.vue?vue&type=script&lang=js&"
export * from "./SourceModal.vue?vue&type=script&lang=js&"
import style0 from "./SourceModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports